export default __webpack_public_path__ + "static/media/a016-7.ff6eb1fa.png";